import SearchPartsExtraFilters from '@/components/SearchParts/SearchPartsExtraFilters';
import SearchPartsTable from '@/components/SearchParts/SearchPartsTable';
import { AppPageHeader, TabContentWrapper } from '@/components/_common';
import {
  FilterTypeEnum,
  ListStockItemsQuery,
  StockItemType,
} from '@/core/domain/stock/StockItems/StockItems.types';
import { useDebounce } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import { convertParams, usePersistSearchParams } from '@/utils/queryParams';
import { Form } from 'antd';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

type TranslateTypes = 'label' | 'column' | 'button' | 'option';

export default function SearchPartsPage({ route }: PageProps) {
  const [form] = Form.useForm();

  const [queryParams, setQueryParams] = useState<ListStockItemsQuery>({
    itemType: StockItemType.Part,
    order: 'ASC',
    filterType: FilterTypeEnum.free,
    active: true,
    isPartReplacement: true,
    ...convertParams<ListStockItemsQuery>({
      ids: 'array-number',
      active: 'boolean',
      itemType: 'string',
      below: 'boolean',
      barcode: 'string',
      originalCode: 'string',
      manufacturingCode: 'string',
      manufacturer: 'string',
      subGroup: 'string',
      description: 'string',
      observation: 'string',
      search: 'string',
      orderColumns: 'string',
      vehicleId: 'number',
      partReplacement: 'number',
      companyCode: 'string',
      sku: 'string',
      filterType: 'string',
      brandId: 'number',
      modelId: 'number',
      isPartReplacement: 'boolean',
    }),
  });

  const queryDebounce = useDebounce(queryParams, 500);

  usePersistSearchParams(queryDebounce);

  const intl = useIntl().formatMessage;
  const translate = (message: string, type: TranslateTypes = 'label') =>
    intl({ id: `searchParts.${type}.${message}` });

  return (
    <TabContentWrapper title={route.name} permissions={route.permissions}>
      <Helmet title={useIntl().formatMessage({ id: route.name })} />

      <Form form={form}>
        <AppPageHeader
          searchValue={queryParams.search}
          onSearch={(value) =>
            setQueryParams((prev) => ({ ...prev, search: value }))
          }
          extraFilters={
            <SearchPartsExtraFilters
              setQueryParams={setQueryParams}
              queryParams={queryParams}
              showFilterPartReplacement
            />
          }
        />
      </Form>

      <SearchPartsTable
        setQueryParams={setQueryParams}
        translate={translate}
        params={queryDebounce}
      />
    </TabContentWrapper>
  );
}
